import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES]: {
		url: '/company/:companyId/infrastructure_types/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPE]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPES_PREVIEW]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/preview/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPE]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].CREATE_INFRASTRUCTURE_TYPES]: {
		url: '/company/:companyId/infrastructure_types/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PATCH_INFRASTRUCTURE_TYPES]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PUT_INFRASTRUCTURE_TYPES]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].DELETE_INFRASTRUCTURE_TYPES]: {
		url: '/company/:companyId/infrastructure_types/:infrastructureTypesId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
